module.exports = __webpack_public_path__ + "media/images/recruitment/pinterest/pinterest-3-0cbe44d336dc92b2b2798069e3a6641b.jpg";